import { useMetabaseUrl } from "model";
import { useUIStore } from "stores";
import { MetabaseIframe } from "./MetabaseIframe";

export function ProjectInsights() {
  const selectedDashboard = useUIStore(
    (state) => state.selectedProjectDashboard
  );

  const params: { [name: string]: string } = {};
  const { data } = useMetabaseUrl(
    selectedDashboard?.guid ?? null,
    params,
    !!selectedDashboard?.guid
  );

  const metabaseUrl = data?.url ?? "";

  return (
    <div data-dashboard-ready={!!metabaseUrl}>
      <MetabaseIframe metabaseUrl={metabaseUrl}></MetabaseIframe>
    </div>
  );
}
